import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { News } from 'src/app/core/models/news';

@Component({
  selector: 'app-more-news',
  templateUrl: './more-news.component.html',
  styleUrls: ['./more-news.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreNewsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() otherNews!: News[];

  translatedTitles: Map<string, string> = new Map();

  private langChangeSubscription: Subscription | undefined;

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.updateTranslatedTitles();

    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      () => {
        this.updateTranslatedTitles();
        this.cdr.markForCheck();
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['otherNews']) {
      this.updateTranslatedTitles();
    }
  }

  ngOnDestroy(): void {
    this.langChangeSubscription?.unsubscribe();
  }

  private updateTranslatedTitles(): void {
    const lang = this.translateService.currentLang as 'pt' | 'en';
    this.translatedTitles.clear();

    this.otherNews?.forEach((news) => {
      if (!news.id) return;
      const title =
        news.translations?.[lang]?.metadata?.title || news.metadata.title;
      this.translatedTitles.set(news.id, title);
    });
  }

  goToNews(news: News) {
    if (news.metadata.link) {
      window.open(news.metadata.link, '_blank');
    } else {
      this.router.navigate([`client/news/${news.id}`]);
    }
  }
}
